import React from 'react';
import DrawerAccordion from '../../../../../../Components/Drawer/DrawerContents/Accordion/drawerAccordion';
import useRestaurantDrawer from './restaurantDrawer-hooks';
import DrawerItem from '../../../../../../Components/Drawer/DrawerContents/Item/drawerItem';
import CustomDialog from '../../../../../../Components/Dialog/customDialog';
import { useGeneralHooks } from '../../../../../../Hooks/hooks';
import { ICompanyResponse } from '../../../../../../Interfaces/responseTypes';
import { Building } from '../../../../../../Assets/Icons';
import styles from './restaurantdrawer.module.scss';

interface IProps {
  data: ICompanyResponse,
  onCompanyUpdate: () => void,
};

const RestaurantDrawer: React.FC<IProps> = (props) => {
  const { data, onCompanyUpdate } = props;
  const { baseURL, largeScreen } = useGeneralHooks();
  const { open, onClose, dialogComponent, drawerItems, businnesItems } = useRestaurantDrawer(data, onCompanyUpdate);

  return (
    <div className={styles.container}>
      <div className={styles.logoBox}>
        <img src={`${baseURL}${data.logo}`} alt='logo.png' />
      </div>
      <div className={styles.drawerItemsBox}>
        <DrawerAccordion
          itemTitle={data.name}
          itemIcon={Building}
          titleStyle={styles.companyTitle}
          children={
            businnesItems.map((item) => {
              return (
                <DrawerItem
                  key={item.title}
                  onClick={item.onClick}
                  title={item.title}
                  icon={item.icon}
                />
              )
            })
          }
        />
        {
          drawerItems.map((item) => {
            return (
              <DrawerItem
                key={item.title}
                onClick={item.onClick}
                title={item.title}
                icon={item.icon}
              />
            )
          })
        }
      </div>
      <CustomDialog
        open={open}
        onClose={onClose}
        children={dialogComponent}
      />
    </div>
  )
};

export default RestaurantDrawer
